<template>
  <div id="app">
    <div class="header">
      <div class="logo_img" @click="logoClick">
        <div >
          <div class="header-logo">
            <img id="header-img" src="../assets/top-logo.jpg" />
          </div>
        </div>
      </div>
      <div class="menu">
        <el-menu :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333"
           mode="horizontal" @select="handleSelect">
          <el-menu-item index="1" class="header-title">首页</el-menu-item>
          <el-menu-item index="2" class="header-title">乐游上野</el-menu-item>
          <el-menu-item index="3" class="header-title">科普教育</el-menu-item>
          <el-menu-item index="4" class="header-title">游园指南</el-menu-item>
          <el-menu-item index="5" class="header-title">精彩视频</el-menu-item>
          <el-menu-item index="6" class="header-title">关于我们</el-menu-item>
        </el-menu>
      </div>
      <div class="login">
        <el-button v-if="loginIn == true" type="text" style="margin-right: 20px" class="header-title"
          @click="loginOut">退出登录
        </el-button>
        <div v-if="loginIn == false">
          <el-button type="text" style="margin-right: 20px" class="header-title" @click="login">登录
          </el-button>
          <el-button type="primary" class="header-title" @click="register" round>注册
          </el-button>
        </div>
      </div>
    </div>
    <div class="container" style="clear: both; padding-top: 65px">
      <router-view></router-view>
    </div>

    <!-- 二级菜单 -->
    <div class="nav" >
      <!-- 一级 -->
      <div class="first-nav">
        <div :class="currIndex == index ? 'first-nav-active' : 'first-nav-list'" v-for="(item, index) in firstNavList"
          :key="index" @click="clickFirst(item, index)">
          <img class="first-icon" :src="item.iconFile" alt="" />
          <div class="first-name">{{ item.naviagtionName }}</div>
        </div>
      </div>
      <!-- 二级 -->
      <div class="second-nav">
        <div :class="tabActiveIndex == i ? 'second-nav-active' : 'second-nav-list'" v-for="(o, i) in secondNavList"
          :key="i" @click="clickSecond(o, i)">
          <div class="second-name">{{ o.groupName }}</div>
        </div>
      </div>
    </div>

    <!-- 订单列表 -->
    <div class="order-list">
      <div class="order-list-i" v-for="(item, index) in list" :key="index">
          <div class="imgStyle">
            <img :src="item.mobileMainPicPath" alt="" class="imgFont" mode="widthFix"  />
            <div class="pop" v-if="item[goodsOptions[groupTypes].goodsDesc].length>0">
              {{item[goodsOptions[groupTypes].goodsDesc].filter(t=>t!='').join(' | ')}}
            </div>
          </div>
          <div>
            <div class="descStyle">
              <div>{{ item.scenicTicketName }}</div>
            </div>
            <div class="buy-bnt">
              <div style="color: red;font-size: 24px">￥{{ item.salePrice / 100 }}</div>
              <div>
                <el-button class="btnColor" @click="bookBtn(item)">预订
                </el-button>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div style="width: 96%; margin: 20px auto">
      <div style="height: 1px; padding: 0; background-color: #999"></div>
    </div>
    <div style="width: 90%; margin: 20px auto">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12">
          <p class="footer_font">网站名称：上海野生动物园官网</p>
          <p class="footer_font">
            地址：上海市浦东新区南六公路178号
          </p>
          <p class="footer_font">技术支持：上海天畅信息技术有限公司</p>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div>
            <img src="../assets/images/imgCode.jpg" style="width: 100px; height: 100px; border: 0" />
          </div>
          <!--          <div class="footer_font">二维码</div>-->
        </el-col>
      </el-row>
    </div>

    <!-- 弹框 -->
    <el-dialog :title="titleName" class="diaLogStyle" :visible.sync="dialogVisible" :before-close="handleCloseTitleName"
      :close-on-click-modal="false">
      <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-width="80px">
        <el-form-item label="手机号" prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入手机号" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" placeholder="请输入密码" v-model="loginForm.password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword" v-if="registerShow">
          <el-input type="password" placeholder="请输入确认密码" v-model="loginForm.confirmPassword"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="captcha" v-if="registerShow">
          <div style="display: flex">
            <el-input placeholder="请输入验证码" v-model="loginForm.captcha" maxlength="6" style="margin-right: 20px"></el-input>
            <el-button :disabled="disabled" @click="checkAndSendMessage">{{ title }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button style="margin-left: 40%" type="primary" v-if="titleName == '登录'" @click="loginSubmit">{{ titleName }}
          </el-button>
          <el-button style="margin-left: 40%" type="primary" v-else @click="registerSubmit">{{ titleName }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 购票弹框 -->
    <el-dialog title="购票" :width='groupType == 1 ? "45%" : "65%"' class="diaLogStyle" :visible.sync="ticketDialogVisible" :before-close="ticketHandleClose"
      :close-on-click-modal="false">
      <div v-if="termShow" class="info">
          <div class="info_title">
            使用说明
          </div>
          <div class="info_content">
             <div class="info_content_item">
                 <div class="info_content_item_top">
                    <div class="info_content_item_top_title">
                        <i class="el-icon-date icons"></i>
                        <span class="info_content_item_top_title_text">有效日期</span>
                    </div>
                    <div class="info_content_item_top_date">
                      {{ formatDateRange(this.isInRange, this.currentTime, ticketInfo.ticketValidStartTime, ticketInfo.ticketValidEndTime) }}
                    </div>
                 </div>
                 <div class="info_content_item_desc">
                    购买之后有效日期内可使用
                 </div>
             </div>
             <div class="info_content_item">
                 <div class="info_content_item_top">
                    <div class="info_content_item_top_title">
                        <i class="el-icon-alarm-clock icons"></i>
                        <span class="info_content_item_top_title_text">可使用时间段</span>
                    </div>
                    <div class="info_content_item_top_date">
                      {{ticketInfo.validStartCheckTime == "00:00:00" ? "9:00-17:00" : funSplitDate(ticketInfo.validStartCheckTime) + '-'+ funSplitDate(ticketInfo.validEndCheckTime)}}
                    </div>
                 </div>
                 <div class="info_content_item_desc">
                    指定使用时间段内可用
                 </div>
             </div>
          </div>
      </div>
      <el-form :model="ticketForm" :rules="ticketRules" ref="ticketForm" label-width="130px" label-position="left">
        <el-form-item label="游玩日期" prop="date" v-if="groupType == 1 && !termShow">
          <el-date-picker v-model="ticketForm.date" @change="goToDatePickerPage" :picker-options="pickerOptions" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" type="date" placeholder="请选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="当日场次" v-if="ticketInfo.theaterTicketFlag == 1 && this.groupType == 1">
          <div class="plan" v-if="planList && planList.length > 0">
            <div :class="selectedPlanId == b.programPlanId
                ? 'plan-list-active'
                : 'plan-list'
              " v-for="(b, n) in planList" :key="n" @click="choosePlan(b)">
              {{ b.programStartTimeStr }}
            </div>
          </div>
        </el-form-item>

        <el-form-item label="年卡名称" v-if="groupType == 2">
          <div>{{ card.scenicCardName }}</div>
        </el-form-item>

        <el-form-item label="购卡时间（年）" v-if="groupType == 2">
          <div>1</div>
        </el-form-item>

        <el-form-item label="购卡后有效期为" v-if="groupType == 2">
          <div>{{ card.validPeriod }}</div>
        </el-form-item>

        <el-form-item label="游客信息" v-if="groupType == 2">
          <div>
            {{ selectedPersonId.length }}/{{ card.singleTicketMaxNumber }}
          </div>
        </el-form-item>

        <el-form-item label="价格" v-if="!termShow">
          <div style="color: red">￥ {{ price }}</div>
        </el-form-item>
        
        <el-form-item label="购买数量" v-if="groupType == 1">
          <el-input-number v-model="ticketForm.num" @change="addChange" :min="1" :max="30" label="描述文字"></el-input-number>
        </el-form-item>

        <!-- <el-form-item label="是否采集人脸" prop="isAgree" v-if="this.faceCollectFlag == 1 && groupType == 2">
          <div style="display: flex" class="info_content_item_desc">
            <el-radio v-model="isAgree" label="1">同意</el-radio>
            <el-radio v-model="isAgree" label="2">不同意</el-radio>
          </div>
        </el-form-item> -->
        <el-form-item label="联系人" prop="name">
          <div class="person-list">
            <div :class="[
              selectedPersonId.findIndex((s) => s == e.frequentContactId) > -1
                ? 'person-info-active'
                : 'person-info',
            ]" v-for="(e, x) in personList" :key="x" @click="choosePerson(e)">
              <div class="info_item_title">{{ e.certificateName }}</div>
            </div>
            <div class="person-add">
              <el-button type="primary" @click="personListDialogVisible = true">新增更换</el-button>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="持卡人信息" v-if="selectedPersonArr.length && groupType == 2">
          <el-table :data="selectedPersonArr" style="width: 900px">
            <el-table-column prop="certificateName" label="用户姓名" width="70">
            </el-table-column>
            <el-table-column prop="phoneNumber" label="手机号码" width="100">
            </el-table-column>
            <el-table-column prop="certificateType" label="证件类型" width="100">
            </el-table-column>
            <el-table-column prop="certificateNo" label="证件号码" width="150">
            </el-table-column>
            <el-table-column prop="provinceId" label="所在省份" width="150">
              <template slot-scope="scope">
                <el-select v-model="scope.row.provinceId" clearable placeholder="请选择省份" @change="changeProvince($event, scope.row.frequentContactId)">
                  <el-option v-for="item in provinceList" :key="item.provinceId" :label="item.provinceName" :value="item.provinceId">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="cityId" label="所在城市" width="150">
              <template slot-scope="scope">
                <el-select v-model="scope.row.cityId" clearable placeholder="请选择城市" @change="changeCity($event,scope.row.frequentContactId)">
                  <el-option v-for="item in cityList" :key="item.cityId" :label="item.cityName" :value="item.cityId">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="districtId" label="所在区县" width="150">
              <template slot-scope="scope">
                <el-select v-model="scope.row.districtId" clearable placeholder="请选择区县" @change="changeDistrict($event,scope.row.frequentContactId)">
                  <el-option v-for="item in districtList" :key="item.districtId" :label="item.districtName" :value="item.districtId">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="所在街镇" width="180">
              <template slot-scope="scope">
                <el-input v-model="scope.row.address" clearable placeholder="请输入街镇"></el-input>
              </template>
            </el-table-column>
            <!-- &&isAgree=='1' -->
            <el-table-column fixed="right" label="人脸" width="100" v-if="this.faceCollectFlag == 1 ">
              <template slot-scope="scope">
                <el-upload ref="fileUploadBtn" class="avatar-uploader" 
                  :action="action" 
                  :data="uploadData" 
                  :headers="headers"
                  :show-file-list="false" 
                  list-type="picture" 
                  :limit="1"
                  :file-list="fileList"
                  :on-success="(response, file, fileList) => handleAvatarSuccess(response, file, fileList, scope.row)"
                  :before-upload="beforeAvatarUpload"
                  >
                  <img v-if="scope.row.photoAbsPath" class="avatar" :src="scope.row.photoAbsPath" mode="widthFix">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item label="支付方式" prop="captcha">
          <div style="display: flex">
            <el-radio v-model="radio" label="1"><img style="width: 44px; height: 44px"
                src="https://paystatic.zhiyoubao.com/image/channelLogo/8b6a41d159bd417998b023b5c4be6a54.png"
                alt="" /></el-radio>
            <el-radio v-model="radio" label="2"><img style="width: 44px; height: 44px"
                src="https://paystatic.zhiyoubao.com/image/channelLogo/02e4dc637bcb402fa9c1ca8197141c3f.png"
                alt="" /></el-radio>
          </div>
        </el-form-item>

        <el-form-item label="总额" v-if="groupType == 1">
          <div style="color: red">￥ {{ maney1 }} </div>
        </el-form-item>

        <el-form-item>
          <el-button style="margin-left: 40%" type="primary" @click="groupType == 2 ? payCard() : goPay()">提交订单
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="付款" class="diaLogStyle" :visible.sync="codeDialogVisible" :before-close="codeClose"
      :close-on-click-modal="false" width="400px" style="text-align: center">
      <div class="payOrder-content">
        <div class="payTime">
          <div class="font28">支付剩余时间：</div>
          <div class="font28">{{ countDownTime.m }}：{{ countDownTime.s }}</div>
        </div>
        <div class="payMoney">
          <div class="priceIcon">￥</div>
          <div class="priceNum">{{ maney1 }}</div>
        </div>
      </div>
      <vue-qr :text="codeText" :size="300" :margin="40" colorDark="#333" colorLight="#fff"
        backgroundColor="#eee"></vue-qr>
      <div class="loadingText">{{ loadingText }}</div>
    </el-dialog>

    <!-- 新增更换 -->
    <el-dialog title="新增更换" :visible.sync="personListDialogVisible" width="700px" :before-close="clickPersonListDialog" :close-on-click-modal="false">
      <el-button type="primary" @click="handleClick('add')">新增</el-button>
      <el-table :data="personList" style="width: 100%">
        <el-table-column prop="certificateName" label="用户姓名" width="100">
        </el-table-column>
        <el-table-column prop="phoneNumber" label="手机号码" width="100">
        </el-table-column>
        <el-table-column prop="certificateType" label="证件类型" width="100">
        </el-table-column>
        <el-table-column prop="certificateNo" label="证件号码" width="180">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick('edit', scope.row)" type="text" size="small">修改</el-button>
            <el-button type="text" size="small" @click="handleDele(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 编辑新增联系人 -->
    <el-dialog :title="titleContact" :visible.sync="showContact" width="700px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form :model="addEditform" :rules="rules" ref="addEditform" label-width="80px">
        <el-form-item label="用户姓名" prop="certificateName">
          <el-input v-model="addEditform.certificateName"></el-input>
        </el-form-item>
        <el-form-item label="证件号码">
          <el-input placeholder="身份证" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="证件号码" prop="certificateNo">
          <el-input v-model="addEditform.certificateNo"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phoneNumber">
          <el-input v-model="addEditform.phoneNumber" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addPerson('addEditform')">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 放弃/购买协议 -->

    <el-dialog :title="titleAgreement" :visible.sync="showAgreement" :close-on-click-modal="false" width="700px">
      <div v-html="card.reservationNotes" ></div>
      <el-button type="primary" @click="clickAgreement">我已阅读并同意</el-button>
    </el-dialog>

    <!-- 签字版 -->
    <el-dialog title="电子签名" :visible.sync="signinVisible" width="700px" :close-on-click-modal="false">
      <signinDia  @setsignin="setsignin" :signinVisible="signinVisible"></signinDia>
    </el-dialog>
  </div>
</template>

<script>
import {
  findWebStorePageNavigationList,
  queryStoreProductGroupList,
  memberLogin,
  appRegistry,
  generateDynamicCode,
  findAppScenicCardListByGroupIds,
  createOrder,
  orderOnlinePay,
  findMemberFrequentContacts,
  queryShopTicketByNo,
  deleteMemberFrequentContact,
  updateMemberFrequentContact,
  addMemberFrequentContact,
  checkPayStatus,
  findProgramPlanListByProjectId,
  findAppScenicCardById,
  getPdfFileUrl,
  confirmFace,
  checkFaceQuality,
  appSaleCard,
  getPriceCalendar,
  findProvinceSelect,
  findCitySelect,
  findDistrictSelect
} from "@/api/api";
import { intervalTime } from "../api/util.js";
import { Message } from "element-ui";
import VueQr from "vue-qr";
import { fileUploadUrl, businessId, baseMember, URL_BASE } from "@/api/url.js";
import signinDia from "@/components/signinDia.vue";
import datePicker from "../components/date-picker/index";
export default {
  name: "Layout",
  components: { VueQr, signinDia, datePicker },
  data() {
    var testPhoneNumber = (rule, value, callback) => {
      const reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    var testCertificateNo = (rule, value, callback) => {
      const idNo = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (value === "") {
        callback(new Error("请输入身份证"));
      } else if (!idNo.test(value)) {
        callback(new Error("身份证格式不正确"));
      } else {
        callback();
      }
    };
    var testPassword = (rule, value, callback) => {
      let reg = new RegExp(/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+$/);
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入包含数字字母的密码！"));
      } else {
        callback();
      }
    };
    var testAginPassword = (rule, value, callback) => {
      let reg = new RegExp(/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+$/);
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入包含数字字母的密码！"));
      } else if (value != this.loginForm.password) {
        callback(new Error("两次输入的密码不一致！"));
      } else {
        callback();
      }
    };
    return {
      second: "", //倒计时
      disabled: false, //是否禁用按钮
      timer: null, //计时器
      loginIn: false,
      maney1: 0,
      price: 0,
      pickerOptions: { disabledDate: this.disabledDate },
      timeStart: "",
      timeEnd: "",
      validStartDate: "",
      productParam: {},
      registerShow: false,
      isAgree: "1", //同意采集人脸  1同意 2不同意
      radio: "1",
      titleName: "",
      dialogVisible: false,
      ticketDialogVisible: false,
      ticketForm: {
        date: "",
        num: 1,
        name: "",
        phoneNumber: "",
        idCard: ""
      },
      ticketRules: {
        date: [{ required: true, message: "请选择日期！", trigger: "blur" }]
      },
      loginForm: {
        username: "",
        password: "",
        confirmPassword: "",
        captcha: ""
      },
      loginRules: {
        username: [
          { required: true, validator: testPhoneNumber, trigger: "blur" }
        ],
        password: [
          { required: true, validator: testPassword, trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, validator: testAginPassword, trigger: "blur" }
        ]
      },
      list: [],
      activeIndex: "1",
      company: {
        // qrcode: require("../../static/other/公众号二维码.jpg"),
      },
      currentMenu: "首页",
      firstNavList: [],
      currIndex: 0,
      secondNavList: [],
      tabActiveIndex: 0,
      groupType: null,
      groupTypes: 0,
      personList: [],
      businessType: 1, // 业态类型：1:门票，12:年卡
      paymentTypeId: 3, // 支付类型 3:微信，2:支付宝
      logoImg: "",
      codeText: "",
      codeDialogVisible: false,
      personListDialogVisible: false,
      ticketInfo: null,
      selectedPersonId: [], //选择后的id
      ticketNo: null, //票的no
      planList: [], //场次
      selectedPlanId: "",
      selectedPlanStr: "",
      showContact: false, //
      addEditType: "",
      titleContact: "新增",
      addEditform: {
        frequentContactId: "",
        certificateName: "",
        phoneNumber: "",
        certificateTypeId: 1,
        certificateType: "身份证",
        certificateNo: "",
        certificateNoTM: "",
        phoneNumberTM: "",
        photoPath: ""
      },
      rules: {
        certificateName: [
          { required: true, message: "请输入用户姓名", trigger: "blur" }
        ],
        certificateNo: [
          { required: true, validator: testCertificateNo, trigger: "blur" }
        ],
        phoneNumber: [
          { required: true, validator: testPhoneNumber, trigger: "blur" }
        ]
      },
      selectedPersonArr: [],
      timer: null,
      loadingText: "",
      ticketInfo: {
        scenicTicketName: "",
        productLabel: []
      },
      touristCountFlag: false,
      vipShow: false,
      planList: [],
      countDownTime: {
        // 倒计时
        d: "",
        h: "",
        m: "",
        s: ""
      },
      timers: null,
      autoCancelLimitTime: "",
      //年卡
      saleCardId: "",
      card: {},
      action: URL_BASE + fileUploadUrl + "/capi/fileAction/uploadFile",
      uploadData: { businessId: businessId },
      headers: {
        Authorization: "bearer " + sessionStorage.getItem("access_token"),
        Bizid: businessId,
        Sd: 11
      },
      showAgreement: false,
      titleAgreement: "预定须知",
      signinVisible: false,
      fileList: [],
      isExpire: false,
      //省市区数据
      provinceList: [],
      cityList: [],
      districtList: [],
      termShow: false,
      currentTime: "",
      goodsOptions: [
        {
          goodsDesc: "labelList"
        },
        {
          goodsDesc: "productLabel"
        }
      ],
      faceCollectFlag: 1
    };
  },
  computed: {
    title() {
      return this.disabled ? `重新获取 ( ${this.second} ) s` : "获取验证码";
    },
    customPickerOptions() {
      let that = this;
      return {
        cellClassName(Date) {
          if (that.customDateArr.includes(moment(Date).format("YYYYMMDD"))) {
            // 自定义的类名, 自行确保这个类型的唯一性,以免覆盖样式
            return "custom_date_class";
          }
        }
      };
    }
  },
  created() {
    this.getFirstNav();
    this.loginIn = sessionStorage.getItem("access_token") ? true : false;
  },
  methods: {
    funSplitDate(time) {
      if (!time) {
        return ""; // 或者返回一个默认值
      }
      let parts = time.split(":");
      if (parts.length < 2) {
        return ""; // 或者返回一个默认值
      }

      let hourMinute = parts[0] + ":" + parts[1];
      return hourMinute;
    },
    funStartDate(dateTimeStr) {
      if (!dateTimeStr) {
        // console.error('dateTimeStr is undefined or null');
        return ""; // 或者返回一个默认值
      }
      let parts = dateTimeStr.split(" ")[0];
      console.log("parts===", parts);
      return parts;
    },
    funEndDate(dateTimeStr) {
      if (!dateTimeStr) {
        // console.error('dateTimeStr is undefined or null');
        return ""; // 或者返回一个默认值
      }
      return dateTimeStr.split(" ")[0];
    },
    formatDateRange(isInRange, currentTime, startTime, endTime) {
      if (isInRange) {
        return `${this.funStartDate(currentTime)} ~ ${this.funEndDate(
          endTime
        )}`;
      } else {
        return `${this.funStartDate(startTime)} ~ ${this.funEndDate(endTime)}`;
      }
    },
    parseDateTime(dateTimeStr) {
      return new Date(dateTimeStr);
    },
    isDateTimeInRange(targetStr, startStr, endStr) {
      const targetDate = this.parseDateTime(targetStr);
      const startDate = this.parseDateTime(startStr);
      const endDate = this.parseDateTime(endStr);
      return targetDate >= startDate && targetDate <= endDate;
    },
    // 省市区数据
    getProvinceList() {
      findProvinceSelect().then(res => {
        if (res.code == 200) {
          this.provinceList = res.data;
        }
      });
    },
    changeProvince(event, id) {
      console.log("event", event);
      if (event) {
        this.getCityList(event);
        this.selectedPersonArr = this.selectedPersonArr.map(v => {
          if (v.frequentContactId == id) {
            delete v.cityId;
            delete v.districtId;
            delete v.address;
          }
          return v;
        });
      }
    },
    getCityList(id = "") {
      findCitySelect({ provinceId: id }).then(res => {
        if (res.code == 200) {
          this.cityList = res.data;
        }
      });
    },
    changeCity(event, id) {
      if (event) {
        this.getDistrictList(event);
        this.selectedPersonArr = this.selectedPersonArr.map(v => {
          if (v.frequentContactId == id) {
            delete v.districtId;
            delete v.address;
          }
          return v;
        });
      }
    },
    getDistrictList(id = "") {
      findDistrictSelect({ cityId: id }).then(res => {
        if (res.code == 200) {
          console.log("getDistrictList", res.data);
          this.districtList = res.data;
        }
      });
    },
    changeDistrict(event, id) {
      this.selectedPersonArr = this.selectedPersonArr.map(v => {
        if (v.frequentContactId == id) {
          delete v.address;
        }
        return v;
      });
    },
    // 控制日期可购买选择
    disabledDate(time) {
      // if (this.isExpire) {
      //   return (
      //     time.getTime() > this.timeEnd || time.getTime() < new Date().getTime()
      //   );
      // } else {
      return (
        time.getTime() > this.timeEnd ||
        time.getTime() < new Date().getTime() - 86400000
      );
      // }
    },
    // 获取可购买日期
    getCalendarList() {
      getPriceCalendar({
        scenicTicketNo: this.ticketNo
      }).then(res => {
        if (res.code == 200) {
          if(res.data) {
            let dateEnd1 = res.data[res.data.length - 1].date;
          let dateEnd2 = new Date(dateEnd1);
          let dateStart = new Date(res.data[0].date);
          this.timeStart = dateStart.getTime();
          this.timeEnd = dateEnd2.getTime();
          console.log("calendarList--termShow", this.termShow);
          // this.ticketForm.date = res.data[0].date;
          }else {
            this.$message.error('未查询到该票详情');
            this.ticketHandleClose()
            
          }
          
        }
      });
    },
    personCheck() {
      let isSuccess = true;
      this.selectedPersonArr.map((v, index) => {
        if (v.provinceId == null) {
          isSuccess = false;
          return this.$message.error(`请选择持卡人${index + 1}的所在省份！`);
        }
        if (v.cityId == null) {
          isSuccess = false;
          return this.$message.error(`请选择持卡人${index + 1}的所在城市！`);
        }
        if (v.districtId == null) {
          isSuccess = false;
          return this.$message.error(`请选择持卡人${index + 1}的所在区县！`);
        }
        if (v.address == null) {
          isSuccess = false;
          return this.$message.error(`请选择持卡人${index + 1}的所在街道！`);
        }
      });
      return isSuccess;
    },
    // 年卡购买校验
    payCard() {
      console.log("selectedPersonArr", this.selectedPersonArr);
      if (this.selectedPersonArr.length == 0) {
        return this.$message.error("请选择联系人！");
      }
      if (!this.personCheck()) {
        return;
      }
      let num = 0;
      // this.isAgree == "1" &&
      if (this.faceCollectFlag ==1) {
        this.selectedPersonArr.map(v => {
          if (!v.photoAbsPath) {
            num++;
          } else {
            v.facePicPath = v.photoPath;
          }
        });
        if (num) {
          this.$message.error("请上传人脸");
        //   this.$confirm("您已勾选同意上传人脸，若不想上传人脸，请取消同意上传人脸选项", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "warning"
        // })
          return
        }
      }

      if (this.card.singleTicketMaxNumber > this.selectedPersonArr.length) {
        this.$confirm("所选人数少于年卡可持有人数,是否继续购买？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.showAgreement = true;
          this.titleAgreement = "放弃协议";
          this.card.reservationNotes = this.card.productIntroduction;
        });
      } else {
        this.showAgreement = true;
        this.titleAgreement = "预定须知";
      }
    },
    goPay() {
      //马戏
      if (this.ticketInfo.theaterTicketFlag == 1 && !this.selectedPlanId) {
        return this.$message.error("请选择场次！");
      }

      if (this.selectedPersonArr.length == 0) {
        return this.$message.error("请选择联系人！");
      }
      this.ticketForm.radio = this.radio;
      this.ticketForm.price = this.price;
      this.ticketForm.maney1 = this.maney1;
      let params = {
        couponQrCodeList: [], //使用优惠券唯一码列表
        tackUserName: this.selectedPersonArr[0].certificateName,
        phoneAreaNumber: "86",
        tackPhoneNumber: this.selectedPersonArr[0].phoneNumber,
        tackCertificateTypeId: 1,
        tackCertificateNo: this.selectedPersonArr[0].certificateNo,
        remark: "",
        saleChannelType: 3,
        orderDetailList: [
          {
            arriveDT:
              this.ticketInfo.ticketDateType == 3 ? "" : this.ticketForm.date,
            scenicTicketNo: String(this.productParam.scenicTicketNo),
            saleSum: this.ticketForm.num,
            orderCertificateList: this.selectedPersonArr
          }
        ]
      };
      if (this.ticketInfo.theaterTicketFlag == 1) {
        params.programPlanId = this.selectedPlanId;
      }
      this.businessType = 1;
      this.$refs["ticketForm"].validate(valid => {
        if (valid) {
          createOrder(params).then(res => {
            if (res.code == "200") {
              let orderNo = res.data.orderNo;
              let paramsobj = {
                businessType: this.businessType, // 业态类型：1:门票 12年卡
                paymentTypeId: this.radio == 1 ? 3 : 2, // 支付类型
                orderTransactionType: 2,
                orderNo: orderNo,
                officialFlag: 1
              };
              this.autoCancelLimitTime = res.data.autoCancelLimitTime;
              this.getOrderOnlinePay(paramsobj);
            } else {
              Message({ message: res.message, type: "error" });
            }
          });
        }
      });
    },
    getOrderOnlinePay(paramsobj) {
      orderOnlinePay(paramsobj).then(r => {
        if (r.code == 52016 || r.code == 200) {
          this.codeDialogVisible = true;
          this.ticketDialogVisible = false;
          this.codeText = r.data.paymentQrCode;
          this.loadingText = r.message;
          this.setInterval(r.data.orderPaymentBatchNo);
          if (this.autoCancelLimitTime) {
            let time =
              new Date(this.autoCancelLimitTime).getTime() -
              new Date().getTime();
            this.countDown(time);
          } else {
            this.countDown();
          }
        } else {
          Message({ message: res.message, type: "warning" });
        }
      });
    },
    setInterval(val) {
      this.timer = setInterval(() => {
        this.checkStatus(val);
      }, 3000);
    },
    clearTimer() {
      clearInterval(this.timer);
      clearInterval(this.timers);
      this.timer = null;
      this.timers = null;
    },
    // //查询订单支付状态
    /**
     * @param {Object} orderPaymentBatchNo //订单批次号
     * @param {Object} check  //是否需要查支付结果
     * @param {Object} titleText 支付后提示文案
     */
    checkStatus(orderPaymentBatchNo) {
      checkPayStatus({
        businessType: this.businessType,
        orderPaymentBatchNo: orderPaymentBatchNo
      }).then(res => {
        if (res.code == "200" || res.code == "52007") {
          this.$message({
            message: "您已下单成功，请至上海野生动物园官方小程序查看订单！",
            type: "success"
          });
          this.clearTimer();
          this.codeDialogVisible = false;
        } else if (res.code != "52001" && res.code != "52016") {
          this.$message.error(res.message);
          this.clearTimer();
          this.codeDialogVisible = false;
        }
      });
    },
    // 支付倒计时
    countDown(t = 1800000) {
      // countDown(t = 3000) {
      let that = this;
      that.timers = setInterval(() => {
        if (t <= 0) {
          that.clearTimer();
          Message({ message: "订单已超时!", type: "warning", duration: 3000 });
          // setTimeout(() => {
          that.codeDialogVisible = false;
          // }, 3000);
        } else {
          that.countDownTime = intervalTime(t);
        }
        t -= 1000;
      }, 1000);
    },
    // 选择日期
    goToDatePickerPage(e) {
      if (e != null) {
        this.price = this.productParam.salePrice;
        this.maney1 = this.productParam.salePrice.toFixed(2);
        this.getTicketDetail();
      } else {
        this.price = 0;
        this.maney1 = 0;
      }
    },
    addChange(value) {
      this.maney1 = this.computedManey1(this.price, value);
    },
    computedManey1(price, num) {
      const totalPrice = price * num;
      return totalPrice.toFixed(2);
    },
    handleSelect(key) {
      switch (key) {
        case "1":
          window.location.href = "https://www.shwzoo.com";
          break;
        case "2":
          window.location.href =
            "https://www.shwzoo.com/index.do?product&typeId=5";
          break;
        case "3":
          window.location.href =
            "https://www.shwzoo.com/index.do?cases&typeId=1";
          break;
        case "4":
          window.location.href = "https://www.shwzoo.com/index.do?guide";
          break;
        case "5":
          window.location.href = "https://www.shwzoo.com/index.do?video";
          break;
        case "6":
          window.location.href = "https://www.shwzoo.com/index.do?about";
          break;
      }
    },
    loginOut() {
      this.$confirm("是否确定退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        Message({ message: "退出登录成功!", type: "success" });
        sessionStorage.setItem("access_token", "");
        this.loginIn = false;
      });
    },
    login() {
      this.loginForm = {
        username: "",
        password: ""
      };
      this.titleName = "登录";
      this.registerShow = false;
      this.dialogVisible = true;
    },
    // 登录提交
    loginSubmit() {
      let params = {
        loginType: 1,
        cellphoneOrEmail: this.loginForm.username,
        password: this.loginForm.password
      };
      this.$refs["loginForm"].validate(valid => {
        if (valid) {
          memberLogin(params).then(res => {
            if (res.code == "200") {
              Message({ message: "登录成功!", type: "success" });
              sessionStorage.setItem("access_token", res.data.access_token);
              this.dialogVisible = false;
              this.loginIn = true;
              this.headers.Authorization =
                "bearer " + sessionStorage.getItem("access_token");
            } else {
              Message({ message: res.message, type: "warning" });
            }
          });
        }
      });
    },
    register() {
      this.loginForm = {
        username: "",
        password: "",
        confirmPassword: "",
        captcha: ""
      };
      this.titleName = "注册";
      this.registerShow = true;
      this.dialogVisible = true;
    },
    // 注册提交
    registerSubmit() {
      let params = {
        cellphone: this.loginForm.username,
        password: this.loginForm.password,
        confirmPassword: this.loginForm.confirmPassword,
        dynamicCode: this.loginForm.captcha,
        businessId: "10001000029002"
      };
      this.$refs["loginForm"].validate(valid => {
        if (valid) {
          appRegistry(params).then(res => {
            if (res.code == "200") {
              Message({ message: "注册成功!", type: "success" });
              this.dialogVisible = false;
            } else {
              Message({ message: res.message, type: "warning" });
            }
          });
        }
      });
    },
    // 发送验证码
    checkAndSendMessage() {
      let s = 60; //倒计时间
      if (!this.timer) {
        this.second = s;
        this.disabled = true;
        this.timer = setInterval(() => {
          if (this.second > 0 && this.second <= s) {
            this.second--;
          } else {
            this.disabled = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
      let params = {
        cellphone: this.loginForm.username,
        dynamicCodeType: "2"
      };
      this.$refs["loginForm"].validate(valid => {
        if (valid) {
          generateDynamicCode(params).then(res => {
            if (res.code == "200") {
              Message({ message: "短信发送成功!", type: "success" });
            } else {
              Message({ message: "短信发送失败!", type: "warning" });
            }
          });
        }
      });
    },
    bookBtn(e) {
      let tokern = sessionStorage.getItem("access_token");
      if (!tokern) {
        Message({ message: "请先登录再进行后续操作!", type: "warning" });
      } else {
        localStorage.setItem("isToady", true);
        this.selectedPlanId = "";
        this.selectedPersonId = [];
        this.selectedPersonArr = [];
        this.isExpire = false;
        this.ticketForm.num = 1;
        this.card.reservationNotes = "";
        this.radio = "1";
        this.isAgree = '1'
        this.productParam = {
          scenicTicketName: e.scenicTicketName,
          scenicTicketId: e.scenicTicketId,
          scenicTicketNo: e.scenicTicketNo,
          salePrice: e.salePrice / 100
        };
        this.price = this.productParam.salePrice;
        this.maney1 = this.productParam.salePrice.toFixed(2);
        this.ticketDialogVisible = true;
        this.ticketNo = this.productParam.scenicTicketNo;
        this.ticketForm.date = this.getDate();
        this.getPersonList();
        if (this.groupType == 1) {
          this.getTicketDetail();
        } else {
          //年卡
          this.saleCardId = e.scenicCardId;
          this.getScenicCardDetail();
          this.getProvinceList();
        }
      }
    },
    handleCloseTitleName() {
      this.dialogVisible = false;
      this.$refs.loginForm.resetFields();
    },
    ticketHandleClose() {
      this.ticketDialogVisible = false;
      this.clearTimer();
    },
    codeClose() {
      this.codeDialogVisible = false;
      this.clearTimer();
    },
    logoClick() {
      this.$router.push({ name: "Index" });
      this.currentMenu = "首页";
    },
    getPersonList() {
      let params = {};
      findMemberFrequentContacts(params).then(res => {
        if (res.code == 200) {
          this.personList = res.data || [];
          console.log('vvvvvvvaaaaaa',this.personList)
        }
        if (this.selectedPersonArr.length) {
          let arr = [];
          this.selectedPersonArr.map(v => {
            this.personList.forEach(r => {
              if (v.frequentContactId == r.frequentContactId) {
                arr.push(v);
              }
            });
          });
          this.selectedPersonArr = arr;
          
        }
        
      });
    },
    getFirstNav() {
      findWebStorePageNavigationList({ navigateType: 2 }).then(res => {
        if (res.code == 200) {
          res.data.forEach(d => {
            if (d.jumpLinkJson) {
              d.jumpLinkJson = JSON.parse(d.jumpLinkJson);
              let arr = Object.keys(d.jumpLinkJson);
              let obj = d.jumpLinkJson[arr[0]];
              d.groupType = obj.groupType;
            }
          });
          this.firstNavList = res.data;
          this.getSecond(0, this.firstNavList[0]);
        }
      });
    },
    getSecond(index, item) {
      this.groupType = item.groupType;
      this.groupTypes = item.groupType - 1;
      this.navIndex = index;
      this.getList(item.jumpLinkJson);
    },
    getList(item) {
      let itemdata = Object.values(item)[0];
      this.tabActiveIndex = 0;
      this.secondDataList = [];
      let params = {};
      let func = null;
      if (itemdata.groupType == 1) {
        params = {
          storeProductGroupIds: itemdata.productGroupIDs
        };
        func = queryStoreProductGroupList;
      } else if (itemdata.groupType == 2) {
        params = {
          cardGroupIdList: itemdata.cardGroupIds
        };
        func = findAppScenicCardListByGroupIds;
      }
      params.saleChannelType = 3;

      func(params).then(res => {
        if (res.code == 200) {
          const list = res.data;

          if (itemdata.groupType == 1) {
            this.secondNavList = list;
            this.list = this.secondNavList[
              this.tabActiveIndex
            ].scenicTicketDetailList;
          } else {
            list.forEach(e => {
              return (e.groupName = e.cardGroupName);
            });
            this.secondNavList = list;
            this.list = this.secondNavList[
              this.tabActiveIndex
            ].scenicCardInfoList;
            this.list.map(c => {
              c.productLabel = c.productLabel.split(",").filter(f => f);
              c.salePrice = c.cardPrice;
              c.scenicTicketName = c.scenicCardName;
            });
          }
        }
      });
    },
    clickFirst(i, o) {
      this.list = [];
      this.secondNavList = [];
      this.currIndex = o;
      this.tabActiveIndex = 0;
      this.getSecond(this.currIndex, this.firstNavList[this.currIndex]);
    },
    clickSecond(i, o) {
      this.list = [];
      this.tabActiveIndex = o;
      if (this.groupType == 1) {
        this.list = this.secondNavList[
          this.tabActiveIndex
        ].scenicTicketDetailList;
      } else {
        this.list = this.secondNavList[this.tabActiveIndex].scenicCardInfoList;
        this.list.map(c => {
          c.salePrice = c.cardPrice;
          c.scenicTicketName = c.scenicCardName;
          c.productLabel = c.productLabel.split(",").filter(f => f);
        });
      }
    },
    // 获取当前日期
    getDate() {
      let currentDate = new Date();
      let year = currentDate.getFullYear(); // 获取当前年份
      let month =
        currentDate.getMonth() + 1 < 10
          ? "0" + (currentDate.getMonth() + 1)
          : currentDate.getMonth() + 1; // 获取当前月份的日期，不足10补0
      let day =
        currentDate.getDate() < 10
          ? "0" + currentDate.getDate()
          : currentDate.getDate(); // 获取当前几号，不足10补0
      return year + "-" + month + "-" + day;
    },
    // 获取详情
    getTicketDetail() {
      this.selectedPlanId = "";
      let params = {
        scenicTicketNo: this.ticketNo,
        arriveDT: this.ticketForm.date
      };
      queryShopTicketByNo(params).then(res => {
        if (res.code == 200) {
          res.data.productLabel = res.data.productLabel
            .split(",")
            .filter(p => p);
          this.ticketInfo = res.data || {};
          var date = new Date();
          var Y = date.getFullYear();
          var MM =
            date.getMonth() + 1 < 10
              ? "0" + (date.getMonth() + 1)
              : date.getMonth() + 1;
          const D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
          var H =
            date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
          var M =
            date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes();
          var S =
            date.getSeconds() < 10
              ? "0" + date.getSeconds()
              : date.getSeconds();
          const currentDate = H + "" + M + "" + S;

          //当前时间
          const currentTime = `${Y}-${MM}-${D} ${H}:${M}:${S}`;
          const startTime =
            this.ticketInfo.ticketValidStartTime == undefined
              ? ""
              : this.ticketInfo.ticketValidStartTime;
          const endTime =
            this.ticketInfo.ticketValidEndTime == undefined
              ? ""
              : this.ticketInfo.ticketValidEndTime;
          if (startTime != "") {
            // 判断目标日期时间是否在区间内
            this.isInRange = this.isDateTimeInRange(
              currentTime,
              startTime,
              endTime
            );
            if (this.isInRange) {
              // 在的话取当前时间
              this.currentTime = currentTime;
            }
          }

          let stopTime = this.ticketInfo.bookRuleDetailDTO.buyEndTime.replace(
            /:/g,
            ""
          );

          console.log("termShow", this.termShow);
          if (
            this.ticketInfo.bookRuleDetailDTO.buyEndTimeLimitFlag == 0 &&
            stopTime < currentDate &&
            !this.isExpire
          ) {
            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            var year = tomorrow.getFullYear();
            var month = ("0" + (tomorrow.getMonth() + 1)).slice(-2); // 月份是从0开始的
            var day = ("0" + tomorrow.getDate()).slice(-2);
            this.ticketForm.date =
              year.toString() + "-" + month.toString() + "-" + day.toString();
            this.isExpire = true;
            localStorage.setItem("isToady", false);
            this.getTicketDetail();
            console.log("11111111111111111111111111111111111");
          } else {
            this.getCalendarList();
            if (this.ticketInfo.theaterTicketFlag == 1) {
              this.getPlanList();
            }
            console.log("222222222222222222222222222222222222");
          }

          // 判断是否是期票
          if (this.ticketInfo.ticketDateType == "3") {
            this.termShow = true;
          } else {
            this.termShow = false;
          }
        }
      });
    },
    // 场次相关的函数
    getPlanList() {
      let params = {
        scenicTicketNo: this.ticketNo,
        arriveDT: this.ticketForm.date,
        projectId: this.ticketInfo.theaterProjectIdList[0],
        saleChannelType: 3
      };
      findProgramPlanListByProjectId(params).then(res => {
        if (res.code == 200) {
          this.planList = res.data || [];
        }
      });
    },
    choosePlan(item) {
      this.selectedPlanId = item.programPlanId;
      this.selectedPlanStr = item.programStartTimeStr;
    },
    //选择联系人
    choosePerson(e) {
      console.log("e", e);
      // e.photoPath = "";
      // e.provinceId = null;
      // e.cityId = null;
      // e.districtId = null;
      // e.address = "";
      // 普通卡
      if (this.groupType == 1) {
        if (this.ticketInfo.certificateBuyFlag == 1) {
          // 实名制
          if (this.ticketInfo.touristCount == 1 && this.ticketForm.num > 1) {
            let index = this.selectedPersonId.findIndex(
              i => i == e.frequentContactId
            );
            if (index < 0) {
              if (this.selectedPersonId.length >= this.ticketForm.num) {
                this.$message.error(
                  "游客数量最多可选" + this.ticketForm.num + "名"
                );
                return;
              } else {
                this.selectedPersonId.push(e.frequentContactId);
                this.selectedPersonArr.push(e);
              }
            } else {
              this.selectedPersonId.splice(index, 1);
              this.selectedPersonArr.splice(index, 1);
            }
          } else {
            if (this.selectedPersonId[0] == e.frequentContactId) {
              this.selectedPersonId = [];
              this.selectedPersonArr = [];
            } else {
              this.selectedPersonId = [e.frequentContactId];
              this.selectedPersonArr = [e];
            }
          }
        } else {
          if (this.selectedPersonId[0] == e.frequentContactId) {
            this.selectedPersonId = [];
            this.selectedPersonArr = [];
          } else {
            this.selectedPersonId = [e.frequentContactId];
            this.selectedPersonArr = [e];
          }
        }
      } else {
        console.log("年卡");

        // 年卡
        if (this.card.singleTicketMaxNumber == 1) {
          console.log("11");
          if (this.selectedPersonId[0] == e.frequentContactId) {
            this.selectedPersonId = [];
            this.selectedPersonArr = [];
          } else {
            this.selectedPersonId = [e.frequentContactId];
            this.selectedPersonArr = [e];
          }
        } else {
          console.log("22");

          // 年卡-家庭卡
          let index = this.selectedPersonId.findIndex(
            i => i == e.frequentContactId
          );
          if (this.selectedPersonId.length < this.card.singleTicketMaxNumber) {
            if (index < 0) {
              this.selectedPersonId.push(e.frequentContactId);
              this.selectedPersonArr.push(e);
            } else {
              this.selectedPersonId.splice(index, 1);
              this.selectedPersonArr.splice(index, 1);
            }
          } else {
            if (index < 0) {
              this.$message.error(
                "游客数量最多可选" + this.card.singleTicketMaxNumber + "名"
              );
            } else {
              this.selectedPersonId.splice(index, 1);
              this.selectedPersonArr.splice(index, 1);
            }
          }
        }
        console.log('this.selectedPersonArr',this.selectedPersonArr)
        this.selectedPersonArr.forEach(m =>{
          // m.photoPath = m.photoPath
          if(m.certificateTypeId == 7) {
            m.certificateNo = m.certificateNo.slice(0, -6)
          }
        })
      }
    },
    confirm(id) {
      deleteMemberFrequentContact({
        frequentContactId: id
      }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getPersonList();
        }
      });
    },
    //删除
    handleDele(item) {
      this.$confirm("是否删除该条数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.confirm(item.frequentContactId);
      });
    },
    //修改
    handleClick(type, item) {
      this.showContact = true;
      this.addEditform = {
        frequentContactId: "",
        certificateName: "",
        phoneNumber: "",
        certificateTypeId: 1,
        certificateType: "身份证",
        certificateNo: "",
        certificateNoTM: "",
        phoneNumberTM: "",
        photoPath: ""
      };
      this.addEditType = type;
      if (this.addEditType == "add") {
        this.titleContact = "新增";
      } else {
        this.titleContact = "编辑";
        this.addEditform = item;
      }
    },
    // 关闭并重置表单
    handleClose() {
      this.showContact = false;
      this.$refs.addEditform.resetFields();
    },
    addPerson(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          if (this.addEditType == "add") {
            addMemberFrequentContact(this.addEditform).then(res => {
              if (res.code == 200) {
                this.showContact = false;
                Message({ message: "保存成功", type: "success" });
                this.getPersonList();
              } else {
                Message({ message: res.message, type: "error" });
              }
            });
          } else {
            updateMemberFrequentContact(this.addEditform).then(res => {
              this.saveDisabled = false;
              if (res.code == 200) {
                this.showContact = false;
                Message({ message: "修改成功", type: "success" });
                this.getPersonList();
              } else {
                Message({ message: res.message, type: "error" });
              }
            });
          }
        }
      });
    },

    //年卡-详情
    getScenicCardDetail() {
      findAppScenicCardById({
        scenicCardId: this.saleCardId
      }).then(res => {
        if (res.data && res.code == 200) {
          this.card = res.data;
          this.faceCollectFlag = res.data.faceCollectFlag;
          let currentDate = new Date();
          let year = currentDate.getFullYear() + 1; // 获取当前年份
          let month =
            currentDate.getMonth() + 1 < 10
              ? "0" + (currentDate.getMonth() + 1)
              : currentDate.getMonth() + 1; // 获取当前月份的日期，不足10补0
          let day =
            currentDate.getDate() < 10
              ? "0" + currentDate.getDate()
              : currentDate.getDate(); // 获取当前几号，不足10补0
          this.card.validPeriod = year + "年" + month + "月" + day + "日";
        } else {
        }
      });
    },
    async beforeAvatarUpload(file) {},
    handleAvatarSuccess(res, file, fileList, row) {
      this.fileList = []; //解决不能二次上传的问题
      if (res.code == 200) {
        let params = new FormData();
        params.append("file", file);

        // this.getfacePicPath(res.data.filePath,res.data.fileAbsPath, row.frequentContactId)

        // 验证图片质量
        checkFaceQuality({
          imgUrl: res.data.filePath
        }).then(res2 => {
            if (res2.code == 200) {
              this.getfacePicPath(
                res.data.filePath,
                res.data.fileAbsPath,
                row.frequentContactId
              );
            } else {
              Message({ message: res2.message, type: "error" });
            }
          })
          .catch(err => {
            Message({ message: err.message, type: "error" });
          });
      } else {
        Message({ message: res.message, type: "error" });
      }
    },
    clickPersonListDialog() {
      this.personListDialogVisible = false;
    },
    getfacePicPath(url, url2, frequentContactId) {
      this.selectedPersonArr.map(c => {
        if (c.frequentContactId == frequentContactId) {
          c.photoAbsPath = url2;
          c.facePicPath = url;
          c.photoPath = url
        }
      });
    },
    //年卡购买协议
    clickAgreement() {
      this.showAgreement = false;
      this.signinVisible = true;
    },
    //年卡签字板
    setsignin(res) {
      if (res) {
        getPdfFileUrl({
          reservationNotes: this.card.reservationNotes,
          imageUrl: res,
          businessId: businessId
        }).then(res => {
          if (res.code == "200") {
            this.fileAbsPath = res.data.filePath;
            this.signinVisible = false;
            this.createCardOrder();
          }
        });
      }
    },
    //创建订单
    createCardOrder() {
      this.selectedPersonArr.map(v => {
					if (v.certificateTypeId == 7) {
						const now = new Date();
						const time = now.toTimeString().split(' ')[0];
						let newStr = time.replace(/:/g, "")
						v.certificateNo = v.certificateNo + newStr;
					}
          // || (this.faceCollectFlag ==1 && this.isAgree == '2') 
					if( this.faceCollectFlag ==2 ){
						v.photoAbsPath = '';
						v.photoPath = '';
						v.facePicPath = '';
					}
				})
      this.businessType = 12;
      let params = {
        buyerName: this.selectedPersonArr[0].certificateName,
        certificateTypeId: this.selectedPersonArr[0].certificateTypeId,
        certificateNo: this.selectedPersonArr[0].certificateNo,
        phoneNumber: this.selectedPersonArr[0].phoneNumber,
        buyerEmail: "",
        saleChannelType: 3,
        cardholderParamList: this.selectedPersonArr,
        scenicCardId: this.saleCardId,
        agreementFilePath: this.fileAbsPath
      };
      appSaleCard(params)
        .then(res => {
          let orderNoList = res.data.orderNoList;
          let paramsobj = {
            businessType: this.businessType, // 业态类型：1:门票 12年卡
            paymentTypeId: this.radio == 1 ? 3 : 2, // 支付类型
            orderTransactionType: 2,
            orderNoList: orderNoList,
            officialFlag: 1
          };
          this.getOrderOnlinePay(paramsobj);

          var currentTime = new Date();
          currentTime.setMinutes(currentTime.getMinutes() + 30);
          var timestamp = Math.floor(currentTime);
          // 此处时间戳以毫秒为单位
          let date = new Date(parseInt(timestamp));
          let Year = date.getFullYear();
          let Moth =
            date.getMonth() + 1 < 10
              ? "0" + (date.getMonth() + 1)
              : date.getMonth() + 1;
          let Day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
          let Hour =
            date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
          let Minute =
            date.getMinutes() < 10
              ? "0" + date.getMinutes()
              : date.getMinutes();
          let Sechond =
            date.getSeconds() < 10
              ? "0" + date.getSeconds()
              : date.getSeconds();
          let GMT =
            Year +
            "-" +
            Moth +
            "-" +
            Day +
            " " +
            Hour +
            ":" +
            Minute +
            ":" +
            Sechond;
          this.autoCancelLimitTime = GMT;
        })
        .catch(err => {
          Message({ message: err.message, type: "error" });
        });
    }
  }
};
</script>

<style scoped>
.logo_img {
  width: 200px;
  min-width: 200px;
  display: flex;
  align-items: center;
  margin-left: 40px;
  margin-top: 10px;
}
.login {
  width: 200px;
  min-width: 200px;
}

.header-title {
  font-size: 1em;
}

.footer_font {
  font-size: 1em;
}

#menu_index {
  height: 100%;
}

.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 65px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background: #ffffff;
}
.menu {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

#header-img {
  height: 40px;
}

.header-logo {
  height: 50px;
  width: 50px;
  align-self: center;
}

a {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}

.imgStyle {
  height: 280px;
  position: relative;
}

.imgFont {
  width: 100%;
  height: 260px;
}

.descStyle {
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  height: 50px;
  min-height: 50px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btnColor {
  background-color: #ef4630;
  color: #ffffff;
}

.btnColor:hover,
.btnColor:active,
.btnColor:visited,
.btnColor:focus {
  background-color: #ef4630;
  color: #ffffff;
}

.nav {
  display: flex;
  flex-direction: column;
  margin: 30px 20px 30px;
  margin-left: 40px;
  align-items: center;
}

.first-nav {
  display: flex;
  flex-direction: row;
}

.first-nav-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 60px;
}

.first-nav-active {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 60px;
  border-bottom: 3px solid #ef4630;
  padding-bottom: 20px;
}

.first-icon {
  width: 50px;
  height: 50px;
}

.second-nav {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}

.second-nav-list {
  margin-right: 60px;
  color: #999;
}

.second-nav-active {
  margin-right: 60px;
  color: #000000;
  padding-bottom: 20px;
  font-weight: 600;
}

.person-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}

.blue-button {
  background-color: #2f71bd;
}
.person-add {
  margin-bottom: 10px;
}

.person-info {
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: 60px; */
  min-width: 60px;
  padding: 0 10px;
  height: 30px;
  border: 1px solid #b8b8b8;
  margin-right: 20px;
  margin-bottom: 10px;
  color: #9b9b9b;
}

.person-info-active {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 60px;
  padding: 0 10px;
  height: 30px;
  border: 1px solid #ffc500;
  background-color: #ffc500;
  margin-right: 20px;
  margin-bottom: 10px;
  color: #fff;
}
.order-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 0 20px 200px;
}
.order-list-i {
  width: 23%;
  margin: 0 9px 40px;
}

.plan {
  display: flex;
  flex-direction: row;
}

.plan-list {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 30px;
  border: 1px solid #b8b8b8;
  margin-right: 20px;
  color: #9b9b9b;
}

.plan-list-active {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 30px;
  border: 1px solid #ffc500;
  background-color: #ffc500;
  margin-right: 20px;
  color: #fff;
}

.loadingText {
  padding: 20px 0 0;
  font-size: 16px;
}

.payOrder-content {
  padding: 0 0 10px;
  width: 100%;
}

.font28 {
  font-size: 14px;
  color: #303030;
  letter-spacing: 0.88px;
  font-weight: 800;
}

.payTime,
.payMoney {
  display: flex;
  justify-content: center;
  align-items: center;
}

.payMoney {
  margin-top: 5px;
  font-size: 20px;
  color: #ff6722;
  letter-spacing: 2.14px;
  font-weight: bolder;
}

.priceIcon {
  font-size: 12px;
  color: #ff6722;
  letter-spacing: 1.21px;
  font-weight: bolder;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.avatar {
  width: 60px;
  /* height: 60px; */
}
.avatar-uploader-icon {
  font-size: 24px;
}

.upload-i {
  font-size: 26rpx;
  font-family: PingFang SC;
  font-weight: bold;
  text-decoration: underline;
  color: #02b660;
}
.buy-bnt {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.info {
}
.info_title {
  font-size: 16px;
  font-weight: 600;
}
.info_content {
  border: 1px solid #ccc;
  width: 400px;
  padding: 15px 20px;
  margin: 15px 0;
}
.info_content_item {
  margin-top: 15px;
}
.info_content_item_top {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #000000;
  font-weight: 600;
}

.info_content_item_top_title_text {
  padding-left: 10px;
}

.info_content_item_top_date {
}
.info_content_item_desc {
  margin-top: 10px;
}
.icons {
  font-size: 14px;
  color: #ef4630;
}
.el-icon-alarm-clock {
  font-size: 17px;
}
.pop {
  position: absolute;
  width: 100%;
  padding: 5px;
  background: #02b660d1;
  box-sizing: border-box;
  color: white;
  bottom: 20px;
}
</style>
